export * from './currency';
export * from './titles';

export const emptyObjectSchema = {
  type: 'object',
  properties: {},
};
